
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b1511411862 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b757270678 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b741502550 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a293633841 = numberParserFn([{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b269043170 = pluralGeneratorFn(function(n
) {
  return 'other';
});
Globalize.b379439659 = messageFormatterFn((function(  ) {
  return function(d) { return "ท่องเที่ยว: แพ็กเกจวันหยุด เที่ยวบิน ตั๋วเครื่องบิน และค่าโดยสารราคาถูก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1425335747 = messageFormatterFn((function(  ) {
  return function(d) { return "ใช้คะแนนแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a502685926 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ใช้คะแนน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1101802582 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิดหน้าต่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a341330669 = messageFormatterFn((function(  ) {
  return function(d) { return "ไปยัง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a455101229 = messageFormatterFn((function(  ) {
  return function(d) { return "เช็กอิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1037934530 = messageFormatterFn((function(  ) {
  return function(d) { return "เช็กเอาต์"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1503058475 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกวัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1605393301 = messageFormatterFn((function(  ) {
  return function(d) { return "ผู้เข้าพัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1223295621 = messageFormatterFn((function(  ) {
  return function(d) { return "ค้นหา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1278536443 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้อมูลเพิ่มเติมเกี่ยวกับ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1892840482 = messageFormatterFn((function(  ) {
  return function(d) { return "เปิด " + d["0"] + " ในแท็บใหม่ กลับไปยังแท็บเดิมเพื่อดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1810456451 = messageFormatterFn((function(  ) {
  return function(d) { return "ผลการค้นหา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1280498702 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดเลือกจุดหมายปลายทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a240426804 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดเลือกวันที่เช็คอินที่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1468131317 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกวันเดินทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1001792207 = messageFormatterFn((function(  ) {
  return function(d) { return "วันเช็คเอาท์ต้องอยู่หลังวันเช็คอิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b545946759 = messageFormatterFn((function(  ) {
  return function(d) { return "วันเช็คเอาท์ต้องอยู่หลังวันเช็คอิน 28 วัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a641669443 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดเลือกวันที่เช็คเอาท์ที่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1152849969 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดเลือกจำนวนผู้เดินทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1614542406 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดระบุอายุของเด็กที่เดินทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b33829750 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดระบุอายุของเด็กที่เดินทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b499114072 = messageFormatterFn((function(  ) {
  return function(d) { return "วันเข้าพักต้องเป็นวันภายในทริป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b372070003 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b814235297 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " ห้อง";}, one: function() { return number(d["0"]) + " ห้อง";}, two: function() { return number(d["0"]) + " ห้อง";}, few: function() { return number(d["0"]) + " ห้อง";}, many: function() { return number(d["0"]) + " ห้อง";}, other: function() { return number(d["0"]) + " ห้อง";} }) + ",  ผู้เข้าพัก " + plural(d["1"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["1"]) + " คน";}, one: function() { return number(d["1"]) + " คน";}, two: function() { return number(d["1"]) + " คน";}, few: function() { return number(d["1"]) + " คน";}, many: function() { return number(d["1"]) + " คน";}, other: function() { return number(d["1"]) + " คน";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a1244585777 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["1"]) + " คน";}, one: function() { return number(d["1"]) + " คน";}, two: function() { return number(d["1"]) + " คน";}, few: function() { return number(d["1"]) + " คน";}, many: function() { return number(d["1"]) + " คน";}, other: function() { return number(d["1"]) + " คน";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b1119626291 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["1"]) + " คน";}, one: function() { return number(d["1"]) + " คน";}, two: function() { return number(d["1"]) + " คน";}, few: function() { return number(d["1"]) + " คน";}, many: function() { return number(d["1"]) + " คน";}, other: function() { return number(d["1"]) + " คน";} }) + ", สัตว์เลี้ยง"; }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b115398420 = messageFormatterFn((function(  ) {
  return function(d) { return "ผู้เข้าพัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a674964960 = messageFormatterFn((function(  ) {
  return function(d) { return "เพิ่มห้องที่ " + d["0"] + " แล้ว แก้ไขข้อมูลผู้เข้าพักด้านล่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b830494208 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบห้องเรียบร้อยแล้ว แก้ไขข้อมูลผู้เข้าพักสำหรับห้องที่ " + d["0"] + " ด้านล่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a998344028 = messageFormatterFn((function(  ) {
  return function(d) { return "ยกเลิก ปิดหน้าต่างตัวเลือกผู้เข้าพักโดยไม่บันทึกการเปลี่ยนแปลง แก้ไขข้อมูลผู้เข้าพักด้านล่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a121572892 = messageFormatterFn((function(  ) {
  return function(d) { return "เสร็จสิ้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1856495140 = messageFormatterFn((function(  ) {
  return function(d) { return "บันทึกการเปลี่ยนแปลงและปิดหน้าต่างตัวเลือกผู้เข้าพัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a85914696 = messageFormatterFn((function(  ) {
  return function(d) { return "เพิ่มอีกห้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a678536729 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบห้องพัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a77868961 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบห้องที่ " + d["0"] + " จาก " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a834288417 = messageFormatterFn((function(  ) {
  return function(d) { return "อายุเด็กคนที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1358076345 = messageFormatterFn((function(  ) {
  return function(d) { return "ห้องที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b243742042 = messageFormatterFn((function(  ) {
  return function(d) { return "ห้องที่ " + d["0"] + " จาก " + d["1"] + " ห้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1095067624 = messageFormatterFn((function(  ) {
  return function(d) { return "แก้ไขอายุเด็กคนที่ " + d["0"] + " เป็น " + d["1"] + " ปีแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b465778626 = messageFormatterFn((function(  ) {
  return function(d) { return "ต่ำกว่า 1"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a92806224 = messageFormatterFn((function(  ) {
  return function(d) { return "เด็ก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1626920455 = messageFormatterFn((function(  ) {
  return function(d) { return "(อายุ 0-17)"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1815219194 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "ผู้ใหญ่ " + plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " คน";}, one: function() { return number(d["0"]) + " คน";}, two: function() { return number(d["0"]) + " คน";}, few: function() { return number(d["0"]) + " คน";}, many: function() { return number(d["0"]) + " คน";}, other: function() { return number(d["0"]) + " คน";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a1740148992 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "เด็ก " + plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " คน";}, one: function() { return number(d["0"]) + " คน";}, two: function() { return number(d["0"]) + " คน";}, few: function() { return number(d["0"]) + " คน";}, many: function() { return number(d["0"]) + " คน";}, other: function() { return number(d["0"]) + " คน";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b2117514922 = messageFormatterFn((function(  ) {
  return function(d) { return "ผู้ใหญ่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1543499054 = messageFormatterFn((function(  ) {
  return function(d) { return "ลดจำนวนเด็กในห้องที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b344917928 = messageFormatterFn((function(  ) {
  return function(d) { return "ลดจำนวนผู้ใหญ่ในห้องที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b777281362 = messageFormatterFn((function(  ) {
  return function(d) { return "เพิ่มจำนวนเด็กในห้องที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1327385908 = messageFormatterFn((function(  ) {
  return function(d) { return "เพิ่มจำนวนผู้ใหญ่ในห้องที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a231010208 = messageFormatterFn((function(  ) {
  return function(d) { return "สัตว์เลี้ยง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1475056956 = messageFormatterFn((function(  ) {
  return function(d) { return "นำสัตว์เลี้ยงเข้าพักหรือไม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b697151824 = messageFormatterFn((function(  ) {
  return function(d) { return "ใช่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1809034398 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ใช่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1495666644 = messageFormatterFn((function(  ) {
  return function(d) { return "เพิ่ม " + d["0"] + " ลงในรายการที่พักโปรดเรียบร้อยแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b782396454 = messageFormatterFn((function(  ) {
  return function(d) { return "เปิดในหน้าต่างใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1481134149 = messageFormatterFn((function(  ) {
  return function(d) { return "รีวิวจากผู้เข้าพัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2086479069 = messageFormatterFn((function(  ) {
  return function(d) { return "ยกเลิกแล้วกลับไปยังหน้ารายละเอียดโรงแรม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b228864235 = messageFormatterFn((function(  ) {
  return function(d) { return "เช็คห้องว่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a566361664 = messageFormatterFn((function(  ) {
  return function(d) { return "ตรวจสอบห้องว่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1107932018 = messageFormatterFn((function(  ) {
  return function(d) { return "เปลี่ยนการค้นหา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1411015695 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกวันเช็คอินวันอื่นที่อยู่ถัดไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1829518229 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกวันเช็คอินวันอื่นที่อยู่ก่อนหน้า"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1247064496 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกวันเช็คเอาท์วันอื่นที่อยู่ถัดไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1993469428 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกวันเช็คเอาท์วันอื่นที่อยู่ก่อนหน้า"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b118317318 = messageFormatterFn((function(  ) {
  return function(d) { return "ราคาเดิมคือ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b3954764 = messageFormatterFn((function(  ) {
  return function(d) { return "ราคาอยู่ที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1927726119 = messageFormatterFn((function(  ) {
  return function(d) { return "ราคาตอนนี้อยู่ที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b120072729 = messageFormatterFn((function(  ) {
  return function(d) { return "ราคาเดิม " + d["0"] + " ราคาปัจจุบัน " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1141864864 = messageFormatterFn((function(  ) {
  return function(d) { return "ต่อคืน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1511525136 = messageFormatterFn((function(  ) {
  return function(d) { return "ยกเลิกแล้วกลับไปยังหน้ารายละเอียดโรงแรม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a30798568 = messageFormatterFn((function(  ) {
  return function(d) { return "รายละเอียดเพิ่มเติม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a857798130 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิดหน้าต่างแล้วกลับไปยังหน้ารายละเอียดโรงแรม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a314048028 = messageFormatterFn((function(  ) {
  return function(d) { return "เกิดข้อผิดพลาดบางประการ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a270898262 = messageFormatterFn((function(  ) {
  return function(d) { return "ลองค้นหาใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1003096286 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูตัวเลือกและจอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1505627279 = messageFormatterFn((function(  ) {
  return function(d) { return "ที่พักอื่นที่น่าสนใจ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a770762434 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิดตัวกรอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1476001354 = messageFormatterFn((function(  ) {
  return function(d) { return "จัดเรียงและกรอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1907378644 = messageFormatterFn((function(  ) {
  return function(d) { return "เสร็จสิ้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1154415017 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบตัวกรอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b271221010 = messageFormatterFn((function(  ) {
  return function(d) { return "คลิกใช้ตัวกรองหรือย้อนกลับเพื่อปิดตัวกรอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1117291152 = messageFormatterFn((function(  ) {
  return function(d) { return "ราคาขั้นต่ำ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1996448766 = messageFormatterFn((function(  ) {
  return function(d) { return "ราคาสูงสุด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1523222471 = messageFormatterFn((function(  ) {
  return function(d) { return "ระดับดาว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b576003320 = messageFormatterFn((function(  ) {
  return function(d) { return "จัดเรียงตาม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a289108631 = messageFormatterFn((function(  ) {
  return function(d) { return "กรองการค้นหาด้วย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1383757143 = messageFormatterFn((function(  ) {
  return function(d) { return "กลับไปยังการค้นหาโรงแรม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b606088755 = messageFormatterFn((function(  ) {
  return function(d) { return "ค้นหาที่พักนับพัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1205437944 = messageFormatterFn((function(  ) {
  return function(d) { return "ค้นหาดีลแพ็กเกจนับพัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1467174460 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "ใช้อยู่ " + plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " ตัวกรอง";}, one: function() { return number(d["0"]) + " ตัวกรอง";}, two: function() { return number(d["0"]) + " ตัวกรอง";}, few: function() { return number(d["0"]) + " ตัวกรอง";}, many: function() { return number(d["0"]) + " ตัวกรอง";}, other: function() { return number(d["0"]) + " ตัวกรอง";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b2120347972 = messageFormatterFn((function(  ) {
  return function(d) { return "จัดเรียงและกรอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b146315376 = messageFormatterFn((function(  ) {
  return function(d) { return "ตัวกรอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1783931299 = messageFormatterFn((function(  ) {
  return function(d) { return "แผนที่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a968590458 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังโหลดผลการค้นหา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1183102747 = messageFormatterFn((function(  ) {
  return function(d) { return "อัพเดทผลการค้นหาแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b609370005 = messageFormatterFn((function(  ) {
  return function(d) { return "เกิดข้อผิดพลาดในการโหลดผลการค้นหา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b325573353 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่พบผลการค้นหา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1216108437 = messageFormatterFn((function(  ) {
  return function(d) { return "ค้นหาโรงแรม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1158141340 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1600051825 = messageFormatterFn((function(  ) {
  return function(d) { return "ลองเปลี่ยนเป็นช่วงวันด้านล่างนี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2141321483 = messageFormatterFn((function(  ) {
  return function(d) { return "แสดงวันที่เพิ่มเติม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2115824697 = messageFormatterFn((function(  ) {
  return function(d) { return "แสดงวันที่น้อยลง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1696640330 = messageFormatterFn((function(  ) {
  return function(d) { return "ผลการค้นหาโรงแรมใน " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1116409306 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ผลการค้นหาที่พักวันหยุด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1812492137 = messageFormatterFn((function(  ) {
  return function(d) { return "ผลการค้นหาโรงแรมไม่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1672142699 = messageFormatterFn((function(  ) {
  return function(d) { return "แสดงเพิ่มเติม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a545961423 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย เราไม่พบผลลัพธ์ โปรดลองปรับการค้นหาของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a195463015 = messageFormatterFn((function(  ) {
  return function(d) { return "ตัวกรองที่เลือกไว้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1752464631 = messageFormatterFn((function(  ) {
  return function(d) { return "ตัวกรองที่เลือกไว้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1281298039 = messageFormatterFn((function(  ) {
  return function(d) { return "ระบุจุดหมายปลายทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b627733483 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1071842357 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบตัวกรองทั้งหมด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a70010356 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "ผู้เข้าพัก " + plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " คน";}, one: function() { return number(d["0"]) + " คน";}, two: function() { return number(d["0"]) + " คน";}, few: function() { return number(d["0"]) + " คน";}, many: function() { return number(d["0"]) + " คน";}, other: function() { return number(d["0"]) + " คน";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b1543426164 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย ระบบของเราเกิดข้อผิดพลาด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a766218471 = messageFormatterFn((function(  ) {
  return function(d) { return "ลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1201688945 = messageFormatterFn((function(  ) {
  return function(d) { return "บันทึก " + d["0"] + " ลงในลิสต์ของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1959973401 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบ " + d["0"] + " จากลิสต์ของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b702792655 = messageFormatterFn((function(  ) {
  return function(d) { return "รายละเอียดสำหรับการเข้าพักครั้งต่อไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1265270566 = messageFormatterFn((function(  ) {
  return function(d) { return "ค้นหาในบริเวณนี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1634670004 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย เกิดข้อผิดพลาด โปรดลองค้นหาอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1998191973 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิดแผนที่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1562050077 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";}, one: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";}, two: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";}, few: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";}, many: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";}, other: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";} }) + " \nเริ่มที่ " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b963142406 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";}, one: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";}, two: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";}, few: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";}, many: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";}, other: function() { return "ที่พัก " + number(d["0"]) + " แห่ง";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a709825773 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูเพิ่มเติม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1470982784 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูน้อยลง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1945702290 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัยค่ะ เกิดข้อผิดพลาดในระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a473066206 = messageFormatterFn((function(  ) {
  return function(d) { return "รายการถัดไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1334599326 = messageFormatterFn((function(  ) {
  return function(d) { return "รายการก่อนหน้า"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a447015557 = messageFormatterFn((function(  ) {
  return function(d) { return "ชำระเงิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1191280730 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "ทริปของคุณ (" + plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " ห้อง";}, one: function() { return number(d["0"]) + " ห้อง";}, two: function() { return number(d["0"]) + " ห้อง";}, few: function() { return number(d["0"]) + " ห้อง";}, many: function() { return number(d["0"]) + " ห้อง";}, other: function() { return number(d["0"]) + " ห้อง";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a196885105 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "ทริปของคุณ (" + plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " ที่พัก";}, one: function() { return number(d["0"]) + " ที่พัก";}, two: function() { return number(d["0"]) + " ที่พัก";}, few: function() { return number(d["0"]) + " ที่พัก";}, many: function() { return number(d["0"]) + " ที่พัก";}, other: function() { return number(d["0"]) + " ที่พัก";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b985392277 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกห้องถัดไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a40952840 = messageFormatterFn((function(  ) {
  return function(d) { return "เต็มแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1460152084 = messageFormatterFn((function(  ) {
  return function(d) { return "ที่พักบางแห่งที่คุณเลือกเต็มแล้ว คุณต้องการจองต่อหรือไม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2146758963 = messageFormatterFn((function(  ) {
  return function(d) { return "ต่อห้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a602980805 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "ผู้เข้าพัก " + plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " คน";}, one: function() { return number(d["0"]) + " คน";}, two: function() { return number(d["0"]) + " คน";}, few: function() { return number(d["0"]) + " คน";}, many: function() { return number(d["0"]) + " คน";}, other: function() { return number(d["0"]) + " คน";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a496399455 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " ห้อง";}, one: function() { return number(d["0"]) + " ห้อง";}, two: function() { return number(d["0"]) + " ห้อง";}, few: function() { return number(d["0"]) + " ห้อง";}, many: function() { return number(d["0"]) + " ห้อง";}, other: function() { return number(d["0"]) + " ห้อง";} }) + ", ผู้เข้าพัก " + plural(d["1"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["1"]) + " คน";}, one: function() { return number(d["1"]) + " คน";}, two: function() { return number(d["1"]) + " คน";}, few: function() { return number(d["1"]) + " คน";}, many: function() { return number(d["1"]) + " คน";}, other: function() { return number(d["1"]) + " คน";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b820231444 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/คืน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1270234956 = messageFormatterFn((function(  ) {
  return function(d) { return "เปลี่ยนห้องพัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b453774424 = messageFormatterFn((function(  ) {
  return function(d) { return "คัดลอกรหัสแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a272830209 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย ระบบของเราเกิดข้อผิดพลาด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a422339390 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดลองค้นหาอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1436138280 = messageFormatterFn((function(  ) {
  return function(d) { return "ลองใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b554732437 = messageFormatterFn((function(  ) {
  return function(d) { return "เวลารับรถและส่งคืนรถ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1138158836 = messageFormatterFn((function(  ) {
  return function(d) { return "เวลารับรถ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1409569824 = messageFormatterFn((function(  ) {
  return function(d) { return "เวลาส่งคืนรถ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2101638017 = messageFormatterFn((function(  ) {
  return function(d) { return "รถเช่า"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a853097068 = messageFormatterFn((function(  ) {
  return function(d) { return "เวลาส่งคืนรถต้องอยู่หลังเวลารับรถอย่างน้อย 2 ชั่วโมง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b554721384 = messageFormatterFn((function(  ) {
  return function(d) { return "00:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b554632011 = messageFormatterFn((function(  ) {
  return function(d) { return "00:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b553797863 = messageFormatterFn((function(  ) {
  return function(d) { return "01:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b553708490 = messageFormatterFn((function(  ) {
  return function(d) { return "01:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b552874342 = messageFormatterFn((function(  ) {
  return function(d) { return "02:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b552784969 = messageFormatterFn((function(  ) {
  return function(d) { return "02:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b551950821 = messageFormatterFn((function(  ) {
  return function(d) { return "03:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b551861448 = messageFormatterFn((function(  ) {
  return function(d) { return "03:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b551027300 = messageFormatterFn((function(  ) {
  return function(d) { return "04:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b550937927 = messageFormatterFn((function(  ) {
  return function(d) { return "04:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b550103779 = messageFormatterFn((function(  ) {
  return function(d) { return "05:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b550014406 = messageFormatterFn((function(  ) {
  return function(d) { return "05:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b549180258 = messageFormatterFn((function(  ) {
  return function(d) { return "06:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b549090885 = messageFormatterFn((function(  ) {
  return function(d) { return "06:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b548256737 = messageFormatterFn((function(  ) {
  return function(d) { return "07:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b548167364 = messageFormatterFn((function(  ) {
  return function(d) { return "07:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b547333216 = messageFormatterFn((function(  ) {
  return function(d) { return "08:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b547243843 = messageFormatterFn((function(  ) {
  return function(d) { return "08:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b546409695 = messageFormatterFn((function(  ) {
  return function(d) { return "09:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b546320322 = messageFormatterFn((function(  ) {
  return function(d) { return "09:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b526092233 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b526002860 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b525168712 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b525079339 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b524245191 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b524155818 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b523321670 = messageFormatterFn((function(  ) {
  return function(d) { return "13:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b523232297 = messageFormatterFn((function(  ) {
  return function(d) { return "13:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b522398149 = messageFormatterFn((function(  ) {
  return function(d) { return "14:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b522308776 = messageFormatterFn((function(  ) {
  return function(d) { return "14:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b521474628 = messageFormatterFn((function(  ) {
  return function(d) { return "15:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b521385255 = messageFormatterFn((function(  ) {
  return function(d) { return "15:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b520551107 = messageFormatterFn((function(  ) {
  return function(d) { return "16:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b520461734 = messageFormatterFn((function(  ) {
  return function(d) { return "16:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b519627586 = messageFormatterFn((function(  ) {
  return function(d) { return "17:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b519538213 = messageFormatterFn((function(  ) {
  return function(d) { return "17:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b518704065 = messageFormatterFn((function(  ) {
  return function(d) { return "18:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b518614692 = messageFormatterFn((function(  ) {
  return function(d) { return "18:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b517780544 = messageFormatterFn((function(  ) {
  return function(d) { return "19:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b517691171 = messageFormatterFn((function(  ) {
  return function(d) { return "19:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b497463082 = messageFormatterFn((function(  ) {
  return function(d) { return "20:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b497373709 = messageFormatterFn((function(  ) {
  return function(d) { return "20:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b496539561 = messageFormatterFn((function(  ) {
  return function(d) { return "21:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b496450188 = messageFormatterFn((function(  ) {
  return function(d) { return "21:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b495616040 = messageFormatterFn((function(  ) {
  return function(d) { return "22:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b495526667 = messageFormatterFn((function(  ) {
  return function(d) { return "22:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b494692519 = messageFormatterFn((function(  ) {
  return function(d) { return "23:00"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b494603146 = messageFormatterFn((function(  ) {
  return function(d) { return "23:30"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1745528487 = messageFormatterFn((function(  ) {
  return function(d) { return "เที่ยวบินตรงเท่านั้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1862122284 = messageFormatterFn((function(  ) {
  return function(d) { return "ชั้นเที่ยวบินที่ต้องการ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b205261548 = messageFormatterFn((function(  ) {
  return function(d) { return "ชั้นประหยัด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a368238451 = messageFormatterFn((function(  ) {
  return function(d) { return "ชั้นประหยัดพรีเมียม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1179186548 = messageFormatterFn((function(  ) {
  return function(d) { return "ชั้นธุรกิจ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1087836340 = messageFormatterFn((function(  ) {
  return function(d) { return "ชั้นหนึ่ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a192165259 = messageFormatterFn((function(  ) {
  return function(d) { return "ผู้เข้าพัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1709833513 = messageFormatterFn((function(  ) {
  return function(d) { return "ต้องมีผู้เดินทางอย่างน้อย 1 คน (อายุ 6 ปีขึ้นไป) ต่อเด็กทารกหนึ่งคนที่นั่งบนตัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1617550354 = messageFormatterFn((function(  ) {
  return function(d) { return "ทารก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1342916965 = messageFormatterFn((function(  ) {
  return function(d) { return "(อายุ 2-17 ปี)"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1548666121 = messageFormatterFn((function(  ) {
  return function(d) { return "อายุต่ำกว่า 2 ปี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1355514491 = messageFormatterFn((function(  ) {
  return function(d) { return "อายุทารกคนที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1581353727 = messageFormatterFn((function(  ) {
  return function(d) { return "ลดจำนวนทารกในห้องที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a590387165 = messageFormatterFn((function(  ) {
  return function(d) { return "เพิ่มจำนวนทารกในห้องที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1341861487 = messageFormatterFn((function(  ) {
  return function(d) { return "เด็กอายุต่ำกว่า 2 ปีต้องนั่งในที่นั่งหรือนั่งตักผู้ใหญ่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a45207255 = messageFormatterFn((function(  ) {
  return function(d) { return "นั่งตัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a853116203 = messageFormatterFn((function(  ) {
  return function(d) { return "นั่งที่นั่ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1237477164 = messageFormatterFn((function(  ) {
  return function(d) { return "กฎเกี่ยวกับอายุผู้โดยสารของสายการบิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a760021920 = messageFormatterFn((function(  ) {
  return function(d) { return "ต้นทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1247607384 = messageFormatterFn((function(  ) {
  return function(d) { return "ออกเดินทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1208705052 = messageFormatterFn((function(  ) {
  return function(d) { return "เดินทางกลับ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1340291710 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดเลือกต้นทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b31500636 = messageFormatterFn((function(  ) {
  return function(d) { return "จองที่พักแค่บางวันเท่านั้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a873621347 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย เกิดข้อผิดพลาดในระบบ โปรดลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1029231087 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกที่พักอย่างน้อยอีก 1 แห่งเพื่อเปรียบเทียบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b641932398 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "เลือกที่พักแล้ว " + d["0"] + "/" + plural(d["1"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["1"]) + " แห่ง";}, one: function() { return number(d["1"]) + " แห่ง";}, two: function() { return number(d["1"]) + " แห่ง";}, few: function() { return number(d["1"]) + " แห่ง";}, many: function() { return number(d["1"]) + " แห่ง";}, other: function() { return number(d["1"]) + " แห่ง";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b1251655222 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "เลือกที่พักเพื่อเปรียบเทียบ " + d["0"] + " จาก " + plural(d["1"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["1"]) + " แห่ง";}, one: function() { return number(d["1"]) + " แห่ง";}, two: function() { return number(d["1"]) + " แห่ง";}, few: function() { return number(d["1"]) + " แห่ง";}, many: function() { return number(d["1"]) + " แห่ง";}, other: function() { return number(d["1"]) + " แห่ง";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b1419234728 = messageFormatterFn((function(  ) {
  return function(d) { return "เปรียบเทียบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1569046844 = messageFormatterFn((function(  ) {
  return function(d) { return "เปรียบเทียบที่พักที่เลือก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a133893086 = messageFormatterFn((function(  ) {
  return function(d) { return "เปรียบเทียบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2123339522 = messageFormatterFn((function(  ) {
  return function(d) { return "เปรียบเทียบที่พักที่เลือก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b115991568 = messageFormatterFn((function(  ) {
  return function(d) { return "ดู"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1970705452 = messageFormatterFn((function(  ) {
  return function(d) { return "คลิกเพื่อดูที่พัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1505912305 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a540283245 = messageFormatterFn((function(  ) {
  return function(d) { return "คลิกเพื่อลบที่พักออกจากการเปรียบเทียบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b727949341 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิดเปรียบเทียบที่พัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2016829981 = messageFormatterFn((function(  ) {
  return function(d) { return "เปรียบเทียบที่พัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1949255334 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูที่พักสูงสุด 5 แห่งพร้อมกันเพื่อตัดสินใจได้ง่ายขึ้น เลือก \"เปรียบเทียบ\" เพื่อเริ่มต้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a297198494 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูที่พักสูงสุด 5 แห่งพร้อมกันเพื่อตัดสินใจได้ง่ายขึ้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1275865398 = messageFormatterFn((function(  ) {
  return function(d) { return "ลองเปรียบเทียบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b897296390 = messageFormatterFn((function(  ) {
  return function(d) { return "เริ่มเปรียบเทียบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b321938734 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิด \"เปรียบเทียบ\""; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1390340878 = messageFormatterFn((function(  ) {
  return function(d) { return "ไว้ทีหลัง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1143216559 = messageFormatterFn((function(  ) {
  return function(d) { return "เปรียบเทียบที่พัก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b539161076 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือก \"เปรียบเทียบ\" ในผลการค้นหาเพื่อเริ่มต้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a465701112 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูที่พักพร้อมกันสูงสุด 5 แห่ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2093276255 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ไม่ว่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1956144190 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่สามารถเช็กเอาต์ในวันที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a949588973 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่สามารถเช็กอินในวันที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1072749953 = messageFormatterFn((function(  ) {
  return function(d) { return "ตกลง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1966194260 = messageFormatterFn((function(  ) {
  return function(d) { return "ปรับแต่งการเข้าพักของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a207590732 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิดการปรับแต่งการเข้าพักของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a381518050 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2021182950 = messageFormatterFn((function(  ) {
  return function(d) { return "ยกเลิก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2084890316 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a182208814 = messageFormatterFn((function(  ) {
  return function(d) { return "เสร็จสิ้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1631534448 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1783985543 = messageFormatterFn((function(  ) {
  return function(d) { return "ที่เลือกไว้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b845716634 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังโหลด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a371759095 = messageFormatterFn((function(  ) {
  return function(d) { return "ล้าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2140613745 = messageFormatterFn((function(  ) {
  return function(d) { return "เปิดในหน้าต่างใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b142081141 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูเพิ่มเติม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1302100584 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูน้อยลง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b158084788 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูเพิ่มเติม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a498263833 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูน้อยลง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a468382066 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือก " + d["0"] + " แล้ว โปรดเลือกวันเช็คเอาท์"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1678541217 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือก " + d["0"] + " แล้ว โปรดเลือกเสร็จสิ้นเพื่อบันทึกวันที่เลือกและปิดปฏิทิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1403626819 = messageFormatterFn((function(  ) {
  return function(d) { return "วันเช็คอินที่เลือก " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1304784830 = messageFormatterFn((function(  ) {
  return function(d) { return "วันเช็คเอาท์ที่เลือก " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1918789908 = messageFormatterFn((function(  ) {
  return function(d) { return "วันที่ที่ไม่สามารถเลือก " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1318907345 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " เดือนปัจจุบัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1734389556 = messageFormatterFn((function(  ) {
  return function(d) { return "ขณะนี้กำลังแสดงเดือน " + d["0"] + " และ " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1703205240 = messageFormatterFn((function(  ) {
  return function(d) { return "หน้าต่างปฏิทินเปิดอยู่ เลือกวันที่จากตารางด้านล่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b148737002 = messageFormatterFn((function(  ) {
  return function(d) { return "ยกเลิกแล้วปิดปฏิทินโดยไม่บันทึกวันที่ที่เลือก หรือเลือกวันที่จากตารางด้านล่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1882225274 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบวันที่เลือก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1648391953 = messageFormatterFn((function(  ) {
  return function(d) { return "บันทึกการเปลี่ยนแปลงและปิดปฏิทิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b542864790 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " คืน";}, one: function() { return number(d["0"]) + " คืน";}, two: function() { return number(d["0"]) + " คืน";}, few: function() { return number(d["0"]) + " คืน";}, many: function() { return number(d["0"]) + " คืน";}, other: function() { return number(d["0"]) + " คืน";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a275341754 = messageFormatterFn((function(  ) {
  return function(d) { return "เช็คอิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b161291445 = messageFormatterFn((function(  ) {
  return function(d) { return "เช็คเอาท์"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1457715220 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบวันที่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1240137045 = messageFormatterFn((function(  ) {
  return function(d) { return "เสร็จสิ้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a609383057 = messageFormatterFn((function(  ) {
  return function(d) { return "ค้นหา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b739745913 = messageFormatterFn((function(  ) {
  return function(d) { return "เปลี่ยนวันเช็คอินจากตารางด้านล่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b252272872 = messageFormatterFn((function(  ) {
  return function(d) { return "เปลี่ยนวันเช็คเอาท์จากตารางด้านล่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b684965799 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1883740468 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณได้เลือก " + d["0"] + " ปิดปฏิทินหรือดำเนินการต่อเพื่อเปลี่ยนวันที่ที่เลือก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1913806276 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณได้เลือก " + d["0"] + " ถึง " + d["1"] + " ปิดปฏิทินหรือดำเนินการต่อเพื่อเปลี่ยนวันที่ที่เลือก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a20633218 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณได้เลือก " + d["0"] + " " + d["1"] + " ปิดปฏิทินหรือดำเนินการต่อเพื่อเปลี่ยนวันที่ที่เลือก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1358511094 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณได้เลือก " + d["0"] + " ถึง " + d["1"] + " " + d["2"] + " ปิดปฏิทินหรือดำเนินการต่อเพื่อเปลี่ยนวันที่ที่เลือก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1005244131 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกวันเช็กอิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1406783638 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกวันเช็กเอาต์"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1801873275 = messageFormatterFn((function(  ) {
  return function(d) { return "ยังไม่ได้เลือกวัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2072037597 = messageFormatterFn((function(  ) {
  return function(d) { return "เดือนที่แล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1152605959 = messageFormatterFn((function(  ) {
  return function(d) { return "เดือนถัดไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1926728024 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้ามไปยังปุ่ม" + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1663079296 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ถึง " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1515561085 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบวันที่แล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1565651984 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "พบผลการค้นหา " + plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " รายการ";}, one: function() { return number(d["0"]) + " รายการ";}, two: function() { return number(d["0"]) + " รายการ";}, few: function() { return number(d["0"]) + " รายการ";}, many: function() { return number(d["0"]) + " รายการ";}, other: function() { return number(d["0"]) + " รายการ";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a527078631 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "พบผลการค้นหา " + plural(d["1"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["1"]) + " รายการ";}, one: function() { return number(d["1"]) + " รายการ";}, two: function() { return number(d["1"]) + " รายการ";}, few: function() { return number(d["1"]) + " รายการ";}, many: function() { return number(d["1"]) + " รายการ";}, other: function() { return number(d["1"]) + " รายการ";} }) + "สำหรับ “" + d["0"] + "” ใช้ปุ่มลูกศรหรือเลื่อนเพื่อเลือกรายการ"; }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b1550920947 = messageFormatterFn((function(  ) {
  return function(d) { return "ค้นหา" + d["0"] + " ป้อนคำค้นหา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1929411074 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณได้เลือก " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a169083359 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิดเมนูแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1200021669 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "ค้นหา " + d["0"] + " ขณะนี้กำลังแสดง " + plural(d["1"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["1"]);}, one: function() { return number(d["1"]);}, two: function() { return number(d["1"]);}, few: function() { return number(d["1"]);}, many: function() { return number(d["1"]);}, other: function() { return number(d["1"]);} }) + " คำแนะนำสำหรับ " + d["2"] + " ไปยังรายการด้านล่าง"; }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a19164914 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "ช่องการค้นหา " + d["0"] + " เปิดอยู่ กำลังแสดงคำแนะนำ " + plural(d["1"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["1"]) + " รายการ";}, one: function() { return number(d["1"]) + " รายการ";}, two: function() { return number(d["1"]) + " รายการ";}, few: function() { return number(d["1"]) + " รายการ";}, many: function() { return number(d["1"]) + " รายการ";}, other: function() { return number(d["1"]) + " รายการ";} }) + " ระบุคำค้นหาหรือเลือกจากรายการด้านล่าง"; }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a1548935634 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "ช่องการค้นหา " + d["0"] + " เปิดอยู่ คุณได้เลือก " + d["1"] + " กำลังแสดงคำแนะนำ " + plural(d["2"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["2"]) + " รายการ";}, one: function() { return number(d["2"]) + " รายการ";}, two: function() { return number(d["2"]) + " รายการ";}, few: function() { return number(d["2"]) + " รายการ";}, many: function() { return number(d["2"]) + " รายการ";}, other: function() { return number(d["2"]) + " รายการ";} }) + " สำหรับ " + d["3"] + " ไปยังรายการด้านล่าง"; }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a1170694356 = messageFormatterFn((function(  ) {
  return function(d) { return "เสร็จสิ้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b605785099 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบทั้งหมด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a703146782 = messageFormatterFn((function(  ) {
  return function(d) { return "รายการที่เลือก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1975214229 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบ " + d["0"] + " แล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a223524046 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบการเลือกทั้งหมดแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1845407261 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณได้ป้อนข้อมูลในช่องการค้นหา โปรดค้นหาหรือเลือกจากหมวดที่แนะนำด้านล่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b225107004 = messageFormatterFn((function(  ) {
  return function(d) { return "ค้นหา “" + d["0"] + "”"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a166454915 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่พบผลการค้นหาสำหรับ “" + d["0"] + "”"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a312419225 = messageFormatterFn((function(  ) {
  return function(d) { return "สนามบิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1944577278 = messageFormatterFn((function(  ) {
  return function(d) { return "โรงแรม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2128254680 = messageFormatterFn((function(  ) {
  return function(d) { return "สถานที่น่าสนใจ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1414548543 = messageFormatterFn((function(  ) {
  return function(d) { return "ใกล้เคียง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1907968258 = messageFormatterFn((function(  ) {
  return function(d) { return "ลองพิมพ์ \"" + d["0"] + "\""; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a278904103 = messageFormatterFn((function(  ) {
  return function(d) { return "ภูมิภาค/เมือง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b275496731 = messageFormatterFn((function(  ) {
  return function(d) { return "สนามบิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b931156125 = messageFormatterFn((function(  ) {
  return function(d) { return "สถานที่ท่องเที่ยว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a369892174 = messageFormatterFn((function(  ) {
  return function(d) { return "โรงแรม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a108288462 = messageFormatterFn((function(  ) {
  return function(d) { return "ที่อยู่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1143913608 = messageFormatterFn((function(  ) {
  return function(d) { return "สถานีรถไฟ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1124473705 = messageFormatterFn((function(  ) {
  return function(d) { return "สถานีรถไฟใต้ดิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b368583429 = messageFormatterFn((function(  ) {
  return function(d) { return "สถานที่ใกล้เคียง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a959249006 = messageFormatterFn((function(  ) {
  return function(d) { return "การค้นหาล่าสุด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2126980844 = messageFormatterFn((function(  ) {
  return function(d) { return "ผู้คนยังค้นหา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1756526111 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูจุดหมายปลายทางยอดนิยม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1385723021 = messageFormatterFn((function(  ) {
  return function(d) { return "จุดหมายปลายทางยอดนิยม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a316892457 = messageFormatterFn((function(  ) {
  return function(d) { return "จุดหมายปลายทางมาแรง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1718270293 = messageFormatterFn((function(  ) {
  return function(d) { return "สถานที่ของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1475254312 = messageFormatterFn((function(  ) {
  return function(d) { return "การแชร์ตำแหน่งที่ตั้งถูกปิดการใช้งาน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b340863192 = messageFormatterFn((function(  ) {
  return function(d) { return "เราไม่สามารถบอกตำแหน่งปัจจุบันของคุณได้ โปรดเปิดบริการหาตำแหน่งที่ตั้งบนมือถือของคุณหรือป้อนจุดหมายปลายทางที่ต้องการ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a105039996 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " ห้อง";}, one: function() { return number(d["0"]) + " ห้อง";}, two: function() { return number(d["0"]) + " ห้อง";}, few: function() { return number(d["0"]) + " ห้อง";}, many: function() { return number(d["0"]) + " ห้อง";}, other: function() { return number(d["0"]) + " ห้อง";} }) + ",  " + plural(d["1"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["1"]) + " คน";}, one: function() { return number(d["1"]) + " คน";}, two: function() { return number(d["1"]) + " คน";}, few: function() { return number(d["1"]) + " คน";}, many: function() { return number(d["1"]) + " คน";}, other: function() { return number(d["1"]) + " คน";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a959799386 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "ผู้เข้าพัก " + plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " คน";}, one: function() { return number(d["0"]) + " คน";}, two: function() { return number(d["0"]) + " คน";}, few: function() { return number(d["0"]) + " คน";}, many: function() { return number(d["0"]) + " คน";}, other: function() { return number(d["0"]) + " คน";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a1430625610 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้อมูลในช่อง " + d["0"] + " ขณะนี้คือ " + d["1"] + " ข้อมูลในช่อง " + d["2"] + " ขณะนี้คือ " + d["3"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2083417657 = messageFormatterFn((function(  ) {
  return function(d) { return "สลับช่อง " + d["0"] + " และ " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1231533990 = messageFormatterFn((function(  ) {
  return function(d) { return "แสดงรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1545876129 = messageFormatterFn((function(  ) {
  return function(d) { return "ซ่อนรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1113001816 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังแสดง " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b561429955 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " จาก " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b837738599 = messageFormatterFn((function(  ) {
  return function(d) { return "ภาพที่ " + d["0"] + " จาก " + d["1"] + " " + d["2"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a337082966 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูภาพถัดไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a611314770 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูภาพก่อนหน้า"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1905818568 = messageFormatterFn((function(  ) {
  return function(d) { return "ดูทั้งหมด " + d["0"] + " ภาพ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1332345171 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "แสดงภาพ " + d["1"] + " " + plural(d["0"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["0"]) + " ภาพ";}, one: function() { return number(d["0"]) + " ภาพ";}, two: function() { return number(d["0"]) + " ภาพ";}, few: function() { return "ทั้งหมด " + number(d["0"]) + " ภาพ";}, many: function() { return "ทั้งหมด " + number(d["0"]) + " ภาพ";}, other: function() { return "ทั้งหมด " + number(d["0"]) + " ภาพ";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.b806041110 = messageFormatterFn((function(  ) {
  return function(d) { return "เสร็จสิ้นแล้ว:"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1925621400 = messageFormatterFn((function(  ) {
  return function(d) { return "ปัจจุบัน:"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b917933626 = messageFormatterFn((function(  ) {
  return function(d) { return "ขั้นตอนที่ " + d["0"] + " จาก " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1178432534 = messageFormatterFn((function(  ) {
  return function(d) { return "ขั้นตอนที่ " + d["0"] + " จาก " + d["1"] + ":"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a667698903 = messageFormatterFn((function(  ) {
  return function(d) { return "ภาพ " + d["0"] + " จาก " + d["1"] + " " + d["2"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1672521452 = messageFormatterFn((function(  ) {
  return function(d) { return "ภาพถัดไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b67224560 = messageFormatterFn((function(  ) {
  return function(d) { return "ภาพก่อนหน้า"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a814561310 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ขยายเพื่อดูแบบเต็มหน้าจอ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1783926966 = messageFormatterFn((function(  ) {
  return function(d) { return "รายการที่ " + d["0"] + " ขยายเพื่อดูแบบเต็มหน้าจอ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a696969268 = messageFormatterFn((function(  ) {
  return function(d) { return "หน้าปัจจุบัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1754249084 = messageFormatterFn((function(  ) {
  return function(d) { return "แสดงลิงก์นำทางเพิ่มเติม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1716427968 = messageFormatterFn((function(  ) {
  return function(d) { return "แสดงลิงก์นำทางน้อยลง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b912487197 = messageFormatterFn((function(  ) {
  return function(d) { return "โหลดอยู่ " + d["0"] + " เปอร์เซ็นต์"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1314115486 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังโหลด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1359917394 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1246645079 = messageFormatterFn((function(  ) {
  return function(d) { return "เกิดข้อผิดพลาด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1743223603 = messageFormatterFn((function(  ) {
  return function(d) { return "ลองชมวิดีโอนี้ทาง www.youtube.com หรือเปิดการใช้งาน Javascript ที่เบราว์เซอร์ของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a722498507 = messageFormatterFn((function(  ) {
  return function(d) { return "เล่นวิดีโอ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a171832325 = messageFormatterFn((function(  ) {
  return function(d) { return "หยุดวิดีโอชั่วคราว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a233951453 = messageFormatterFn((function(  ) {
  return function(d) { return "วิดีโอกำลังโหลด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1731713107 = messageFormatterFn((function(  ) {
  return function(d) { return "โฟโตสเฟียร์"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1190208781 = messageFormatterFn((function(  ) {
  return function(d) { return "คือภาพแบบ 360 องศา ใช้ปุ่มคอนโทรลและปุ่มลูกศร หรือปุ่มคอมมานด์และปุ่มลูกศรเพื่อเลื่อนไปรอบๆ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1754306720 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังแสดง: " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b161049857 = messageFormatterFn((function(  ) {
  return function(d) { return "เลื่อนไปทางซ้าย ตำแหน่ง: " + d["0"] + " องศา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a447636218 = messageFormatterFn((function(  ) {
  return function(d) { return "เลื่อนไปทางขวา ตำแหน่ง: " + d["0"] + " องศา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a889493459 = messageFormatterFn((function(  ) {
  return function(d) { return "เลื่อนไปด้านบน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b380347174 = messageFormatterFn((function(  ) {
  return function(d) { return "เลื่อนลงด้านล่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1728801899 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณอยู่ด้านบนแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1395513025 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณอยู่ด้านล่างแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b343583467 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกทุกแถว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1473882740 = messageFormatterFn((function(  ) {
  return function(d) { return "ยกเลิกการเลือกทุกแถว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b262101372 = messageFormatterFn((function(  ) {
  return function(d) { return "จัดเรียงคอลัมน์จากลำดับสูงไปต่ำ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1315950046 = messageFormatterFn((function(  ) {
  return function(d) { return "จัดเรียงคอลัมน์จากลำดับต่ำไปสูง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b332626574 = messageFormatterFn((function(  ) {
  return function(d) { return "ขณะนี้จัดเรียงลำดับข้อมูลในคอลัมน์จากสูงไปต่ำ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a398362358 = messageFormatterFn((function(  ) {
  return function(d) { return "ขณะนี้จัดเรียงลำดับข้อมูลในคอลัมน์จากต่ำไปสูง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1916839378 = messageFormatterFn((function(  ) {
  return function(d) { return "ขยายแถว " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1343361903 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "แสดง " + d["0"] + " จาก " + plural(d["1"], 0, pluralFuncs["th-TH"], { zero: function() { return number(d["1"]) + " รายการ";}, one: function() { return number(d["1"]) + " รายการ";}, two: function() { return number(d["1"]) + " รายการ";}, few: function() { return number(d["1"]) + " รายการ";}, many: function() { return number(d["1"]) + " รายการ";}, other: function() { return number(d["1"]) + " รายการ";} }); }
})(messageFormat.number, messageFormat.plural, {"th-TH": Globalize("th-TH").pluralGenerator()}), Globalize("th-TH").pluralGenerator({}));
Globalize.a280474943 = messageFormatterFn((function(  ) {
  return function(d) { return "เดือนปัจจุบันของคุณคือ " + d["0"] + " " + d["1"] + " และ " + d["2"] + " " + d["3"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a523169495 = messageFormatterFn((function(  ) {
  return function(d) { return "เดือนปัจจุบันของคุณคือ " + d["0"] + " " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a834271262 = messageFormatterFn((function(  ) {
  return function(d) { return "เดือนปัจจุบันของคุณคือตั้งแต่ " + d["0"] + " " + d["1"] + " - " + d["2"] + " " + d["3"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b198777625 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบวันเช็กอิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2019609040 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบวันเช็กเอาต์"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1058421583 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบวันที่แล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a900442730 = messageFormatterFn((function(  ) {
  return function(d) { return "ลบวันที่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a882794954 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a235774125 = messageFormatterFn((function(  ) {
  return function(d) { return "ถัดไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a690972653 = messageFormatterFn((function(  ) {
  return function(d) { return "ก่อนหน้า"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b743023341 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้ามไปยังปุ่มส่ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b203942714 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้ามไปยังปุ่ม" + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2069666391 = messageFormatterFn((function(  ) {
  return function(d) { return "เดือนถัดไป"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a935077481 = messageFormatterFn((function(  ) {
  return function(d) { return "เดือนที่แล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b458318542 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือก " + d["0"] + " เป็นวันเช็กอินของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b407808663 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือก " + d["0"] + " เป็นวันเช็กเอาต์ของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2016782414 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ไม่ใช่วันเช็กอินที่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1483256905 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ไม่ใช่วันเช็กเอาต์ที่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a339294234 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ไม่ว่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b727301557 = messageFormatterFn((function(  ) {
  return function(d) { return "วันนี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b544498505 = messageFormatterFn((function(  ) {
  return function(d) { return "วันเช็กอินที่เลือกไว้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1526385296 = messageFormatterFn((function(  ) {
  return function(d) { return "วันเช็กเอาต์ที่เลือกไว้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a352452485 = messageFormatterFn((function(  ) {
  return function(d) { return "วันที่เลือก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1205731743 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งแต่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1400979802 = messageFormatterFn((function(  ) {
  return function(d) { return "ถึง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2011946587 = messageFormatterFn((function(  ) {
  return function(d) { return "ยกเลิก ปิดหน้าต่างการเลือกวันที่โดยไม่บันทึกการเปลี่ยนแปลง หรือเลือกวันที่จากตารางด้านล่าง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a907769588 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " จาก " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1096315009 = messageFormatterFn((function(  ) {
  return function(d) { return "กดปุ่ม Esc เพื่อปิด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a842344746 = messageFormatterFn((function(  ) {
  return function(d) { return "กดปุ่ม Esc เพื่อย่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1788887111 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนตัวเลขไม่เกิน " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1342838120 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนตัวเลขมากกว่า " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1073677419 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนตัวเลขระหว่าง " + d["0"] + " - " + d["1"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1744701274 = messageFormatterFn((function(  ) {
  return function(d) { return "จำเป็นต้องระบุ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1343742966 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a501183683 = messageFormatterFn((function(  ) {
  return function(d) { return "ยินดีต้อนรับอีกครั้ง! เข้าสู่ระบบด้วย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b289756361 = messageFormatterFn((function(  ) {
  return function(d) { return "ยินดีต้อนรับอีกครั้ง! เข้าสู่ระบบและจองที่พักหลายพันแห่งได้ประหยัดขึ้นอีกอย่างน้อย 10% ด้วยราคาสำหรับสมาชิก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2091922461 = messageFormatterFn((function(  ) {
  return function(d) { return "อีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b455930358 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1518172985 = messageFormatterFn((function(  ) {
  return function(d) { return "ยังไม่ได้เป็นสมาชิก?"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1576045525 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังเข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1744329640 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบด้วย Facebook"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a866212891 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบด้วย Google"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1756890805 = messageFormatterFn((function(  ) {
  return function(d) { return "ให้ฉันอยู่ในระบบเสมอ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1305077774 = messageFormatterFn((function(  ) {
  return function(d) { return "ให้ฉันอยู่ในระบบเสมอ (ใช้คุกกี้)"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b339176252 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b338816838 = messageFormatterFn((function(  ) {
  return function(d) { return "สมัคร"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1282482218 = messageFormatterFn((function(  ) {
  return function(d) { return "หรือ <a href=\"" + d["0"] + "\">เข้าสู่ระบบด้วย Facebook</a>"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1526920736 = messageFormatterFn((function(  ) {
  return function(d) { return "ลืมรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a806967283 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาป้อนอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a779264457 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนอีเมลที่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1461012474 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาป้อนรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b296974208 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1770452164 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัยค่ะ เกิดข้อผิดพลาดบางประการ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1213926818 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดแก้ไขข้อผิดพลาดด้านล่างเพื่อดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b911656455 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดแก้ไขข้อผิดพลาดที่ 2 ช่องด้านล่างนี้เพื่อดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1251371919 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบด้วยอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b555808958 = messageFormatterFn((function(  ) {
  return function(d) { return "หรือเข้าสู่ระบบด้วยอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1003061703 = messageFormatterFn((function(  ) {
  return function(d) { return "อีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b926182554 = messageFormatterFn((function(  ) {
  return function(d) { return "หรือ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1757833112 = messageFormatterFn((function(  ) {
  return function(d) { return "ลืมรหัสผ่าน?"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b518701227 = messageFormatterFn((function(  ) {
  return function(d) { return "ยังไม่เป็นสมาชิก?"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a139478687 = messageFormatterFn((function(  ) {
  return function(d) { return "สร้างบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b345948656 = messageFormatterFn((function(  ) {
  return function(d) { return "ในการเข้าสู่ระบบ ฉันได้ยอมรับ<a href=\"" + d["0"] + "\" target=\"_blank\">ข้อกำหนดและเงื่อนไขของ " + d["1"] + "<span class=\"is-visually-hidden\">เปิดในหน้าต่างใหม่</span></a> แล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1382056806 = messageFormatterFn((function(  ) {
  return function(d) { return "ในการเข้าสู่ระบบ" + d["0"] + "บัญชี  ฉันได้ยอมรับ<a href=\"" + d["1"] + "\" target=\"_blank\">" + d["2"] + "ข้อตกลงการใช้<span class=\"is-visually-hidden\">งานเปิดในหน้าต่างใหม่</span></a> <a href=\"" + d["3"] + "\" target=\"_blank\">นโยบายความเป็นส่วนตัว<span class=\"is-visually-hidden\">เปิดในหน้าต่างใหม่</span></a> และ<a href=\"" + d["4"] + "\" target=\"_blank\">ข้อกำหนดและเงื่อนไขของ" + d["5"] + "<span class=\"is-visually-hidden\">เปิดในหน้าต่างใหม่</span></a> "; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a337318154 = messageFormatterFn((function(  ) {
  return function(d) { return "สมัคร <a href=\"" + d["0"] + "\" target=\"_blank\">" + d["1"] + "<span class=\"is-visually-hidden\">เปิดในหน้าต่างใหม่</span></a> ในการสมัคร ฉันยอมรับ<a href=\"" + d["3"] + "\" target=\"_blank\">ข้อกำหนดและเงื่อนไขทั้งหมด <span class=\"is-visually-hidden\">เปิดในหน้าต่างใหม่</span></a>"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b889384346 = messageFormatterFn((function(  ) {
  return function(d) { return "เป็นไปตามข้อกำหนด ลิงก์ไปยังข้อกำหนดต่างๆ อยู่ที่ด้านล่างสุดของหน้านี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b814471764 = messageFormatterFn((function(  ) {
  return function(d) { return "เช็คอีเมลของคุณ!"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1562889497 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งค่ารหัสผ่านใหม่จากลิงก์ที่เราส่งไปที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1337243814 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งลิงก์อีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1104454150 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัยค่ะ ระบบเกิดข้อผิดพลาด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a885931775 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2021486758 = messageFormatterFn((function(  ) {
  return function(d) { return "ย้อนกลับ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b795302298 = messageFormatterFn((function(  ) {
  return function(d) { return "เราได้ส่งลิงก์ใหม่ไปให้คุณแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b160082176 = messageFormatterFn((function(  ) {
  return function(d) { return "สร้างบัญชี " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1543726407 = messageFormatterFn((function(  ) {
  return function(d) { return "สร้างบัญชีด้วย..."; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1919686169 = messageFormatterFn((function(  ) {
  return function(d) { return "สร้างบัญชีด้วยอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1337996276 = messageFormatterFn((function(  ) {
  return function(d) { return "หรือสร้างบัญชีด้วยอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1306387900 = messageFormatterFn((function(  ) {
  return function(d) { return "ชื่อและนามสกุล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b720616702 = messageFormatterFn((function(  ) {
  return function(d) { return "นามสกุลและชื่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a424195751 = messageFormatterFn((function(  ) {
  return function(d) { return "8-30 อักขระและไม่เว้นวรรค"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a106759767 = messageFormatterFn((function(  ) {
  return function(d) { return "สร้างบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b643812506 = messageFormatterFn((function(  ) {
  return function(d) { return "มีบัญชีอยู่แล้ว?"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1629442726 = messageFormatterFn((function(  ) {
  return function(d) { return "ในการสร้างบัญชี ฉันได้ยอมรับ " + d["0"] + " <a href=\"" + d["1"] + "\" target=\"_blank\">ข้อตกลงการใช้งาน<span class=\"is-visually-hidden\">เปิดในหน้าต่างใหม่</span></a> <a href=\"" + d["2"] + "\" target=\"_blank\">นโยบายความเป็นส่วนตัว <span class=\"is-visually-hidden\">เปิดในหน้าต่างใหม่</span></a> และ<a href=\"" + d["3"] + "\" target=\"_blank\">" + d["4"] + " ข้อกำหนดและเงื่อนไข <span class=\"is-visually-hidden\">เปิดในหน้าต่างใหม่</span></a>"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1186740545 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันต้องการรับดีลท่องเที่ยว ข้อเสนอพิเศษ และข้อมูลอื่นๆ ทางอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1453243061 = messageFormatterFn((function(  ) {
  return function(d) { return "เราได้ส่งลิงก์ยืนยันการสร้างบัญชีให้คุณผ่านทางอีเมลแล้ว "; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b91757130 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาคลิกลิงก์ในอีเมลที่ส่งถึง " + d["0"] + " เพื่อสร้างบัญชีให้เสร็จสมบูรณ์"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a684585695 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่านใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2049816709 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนอีเมลของคุณเพื่อรับลิงก์สำหรับตั้งรหัสผ่านใหม่จากเรา"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1483927183 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งลิงก์"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1184407167 = messageFormatterFn((function(  ) {
  return function(d) { return "หรือจองในฐานะผู้เยี่ยมชม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b30315545 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่านใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1814776952 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่านใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b929836685 = messageFormatterFn((function(  ) {
  return function(d) { return "อีเมล: " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a986863465 = messageFormatterFn((function(  ) {
  return function(d) { return "บันทึกรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1650285989 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัยค่ะ ลิงก์นี้หมดอายุแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a980491440 = messageFormatterFn((function(  ) {
  return function(d) { return "หากต้องการตั้งรหัสผ่านใหม่ กรุณาขอลิงก์ใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1997739376 = messageFormatterFn((function(  ) {
  return function(d) { return "ขอลิงก์ใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1647008775 = messageFormatterFn((function(  ) {
  return function(d) { return "กลับไปหน้าเข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1236514406 = messageFormatterFn((function(  ) {
  return function(d) { return "เราได้ส่งลิงก์สำหรับตั้งรหัสผ่านใหม่ให้คุณผ่านทางอีเมลแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1120306065 = messageFormatterFn((function(  ) {
  return function(d) { return "ระบุอีเมลของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1313453964 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดระบุอีเมลที่ผู้ให้บริการการเดินทางหรือ" + d["0"] + "สามารถติดต่อคุณได้ จากนั้นเราจะส่งรหัสความปลอดภัยไปให้คุณใช้ยืนยันตัวตน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1088257977 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณสมัคร " + d["0"] + " ด้วยหมายเลขโทรศัพท์ กรุณาระบุอีเมลของคุณเพื่อเข้าสู่ระบบที่เว็บไซต์ของเรา จากนั้นเราจะส่งรหัสความปลอดภัยไปให้คุณใช้ยืนยันตัวตน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2072009926 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งรหัสความปลอดภัย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a390850324 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนรหัสความปลอดภัย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a815897388 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนรหัสความปลอดภัยที่เราส่งไปที่ " + d["0"]; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a262475171 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสความปลอดภัย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b560853537 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2038220907 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่ได้รับอีเมล?"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a496189455 = messageFormatterFn((function(  ) {
  return function(d) { return "ส่งรหัสใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b966144340 = messageFormatterFn((function(  ) {
  return function(d) { return "เราส่งรหัสความปลอดภัยใหม่ไปให้คุณแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1607496719 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนรหัสความปลอดภัยที่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1235563030 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณได้ขอรับรหัสความปลอดภัยครบตามจำนวนครั้งสูงสุดที่กำหนดแล้ว โปรดลองอีกครั้งในอีก 24 ชั่วโมง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b2022384940 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณได้ป้อนรหัสความปลอดภัยที่ไม่ถูกต้องตามจำนวนครั้งสูงสุดที่กำหนดแล้ว โปรดลองอีกครั้งในอีก 24 ชั่วโมง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1601125933 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนรหัสความปลอดภัยที่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a242237353 = messageFormatterFn((function(  ) {
  return function(d) { return "มีการใช้อีเมลที่คุณกรอกสร้างบัญชี" + d["0"] + "ผ่าน " + d["1"] + " แล้ว กรุณาลองเข้าสู่ระบบด้วยบัญชี " + d["1"] + " ที่เชื่อมโยงกับอีเมลดังกล่าว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1025379454 = messageFormatterFn((function(  ) {
  return function(d) { return "เพื่อรักษาความปลอดภัยให้กับบัญชี เราขอให้คุณตั้งรหัสผ่านใหม่ก่อนเข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1549128084 = messageFormatterFn((function(  ) {
  return function(d) { return "หากคุณมีบัญชี " + d["0"] + " อยู่แล้ว เราจะส่งลิงก์ตั้งรหัสผ่านใหม่ไปให้คุณทางอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a541421247 = messageFormatterFn((function(  ) {
  return function(d) { return "ยินดีต้อนรับอีกครั้ง " + d["0"] + "!"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2135605147 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านใหม่ของคุณได้รับการบันทึกไว้แล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1488545391 = messageFormatterFn((function(  ) {
  return function(d) { return "จองต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1057747807 = messageFormatterFn((function(  ) {
  return function(d) { return "ยินดีต้อนรับค่ะ " + d["0"] + "!"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1638705731 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัยค่ะ ระบบเกิดข้อผิดพลาด"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a996596108 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดแก้ไขข้อผิดพลาด " + d["0"] + " แห่งด้านล่างเพื่อดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a160556995 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณป้อนอีเมลที่ไม่มีในระบบ หรือป้อนรหัสผ่านไม่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b971509125 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัยค่ะ เราไม่สามารถเชื่อมต่อกับ " + d["0"] + " ได้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2087953350 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัยค่ะ ลิงก์สำหรับตั้งรหัสผ่านใหม่หมดอายุแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1543489184 = messageFormatterFn((function(  ) {
  return function(d) { return "กรุณาขอลิงก์ใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a636565030 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัยค่ะ เซสชั่นของคุณหมดอายุแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1072388046 = messageFormatterFn((function(  ) {
  return function(d) { return "ป้อนชื่อและนามสกุล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b513495430 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนนามสกุลและชื่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1578545336 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนชื่อโดยใช้ตัวอักษรภาษาอังกฤษเท่านั้น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1962706472 = messageFormatterFn((function(  ) {
  return function(d) { return "อีเมลนี้มีบัญชี " + d["0"] + " อยู่แล้ว  "; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b433666916 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านต้องไม่เว้นวรรค"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1434603005 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านต้องไม่เหมือนกับอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a952362023 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านนี้เดาง่าย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a504584142 = messageFormatterFn((function(  ) {
  return function(d) { return "อีเมลนี้มีอยู่ในระบบแล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1631625023 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1920051355 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านไม่ถูกต้อง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1493737257 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านต้องมีความยาวอย่างน้อย " + d["0"] + " ตัว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a836821207 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านต้องมีความยาว " + d["0"] + "-" + d["1"] + " ตัว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b757127399 = messageFormatterFn((function(  ) {
  return function(d) { return "มีการใช้อีเมลนี้เพื่อสร้างบัญชี " + d["0"] + " ผ่าน " + d["1"] + " แล้ว กรุณาใช้อีเมลอื่น หรือเข้าสู่ระบบด้วยบัญชี " + d["1"] + " ที่เชื่อมโยงกับอีเมลนี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b219646861 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัยค่ะ เราไม่สามารถเข้าสู่ระบบด้วย Apple ID ของคุณได้ เราอยู่ระหว่างดำเนินการเพื่อรองรับการเข้าสู่ระบบด้วย Apple ID ที่เป็นหมายเลขโทรศัพท์ ในระหว่างนี้ กรุณาเข้าสู่ระบบด้วยวิธีอื่น"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a2061241623 = messageFormatterFn((function(  ) {
  return function(d) { return "ไม่พบบัญชีนี้"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1536337976 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดป้อนอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b662582119 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิดการเข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b149795825 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิดการสร้างบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1735010828 = messageFormatterFn((function(  ) {
  return function(d) { return "กลับไปยังหน้าที่แล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1256910483 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิดหน้าต่างการยืนยันทางอีเมล"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b523484281 = messageFormatterFn((function(  ) {
  return function(d) { return "ปิดหน้าต่างป้อนรหัสความปลอดภัย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b16046831 = messageFormatterFn((function(  ) {
  return function(d) { return "จองในฐานะผู้เยี่ยมชม หรือเข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b739747215 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันยังไม่เคยเป็นสมาชิก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1248049680 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณยังสามารถสร้างบัญชีได้หลังการจอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1194792561 = messageFormatterFn((function(  ) {
  return function(d) { return "จองในฐานะผู้เยี่ยมชม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1312081405 = messageFormatterFn((function(  ) {
  return function(d) { return "ฉันเป็นสมาชิกอยู่แล้ว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b92923475 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบเพื่อรับคะแนนสะสมจากการจอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1819090268 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบและจอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1025915979 = messageFormatterFn((function(  ) {
  return function(d) { return "หรือดำเนินการต่อด้วย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a680504037 = messageFormatterFn((function(  ) {
  return function(d) { return "ยินดีต้อนรับอีกครั้ง!"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1010315564 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบหรือสร้างบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1962019425 = messageFormatterFn((function(  ) {
  return function(d) { return "ดำเนินการต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1809681661 = messageFormatterFn((function(  ) {
  return function(d) { return "เราได้ส่งลิงก์การตั้งรหัสผ่านใหม่ไปยัง " + d["0"] + " แล้ว อาจใช้เวลาสักครู่ หากไม่พบอีเมลในกล่องข้อความเข้า กรุณาตรวจสอบโฟลเดอร์ขยะหรือโฟลเดอร์สแปม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1707654950 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่านใหม่"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1404265026 = messageFormatterFn((function(  ) {
  return function(d) { return "รหัสผ่านต้องมีความยาวอย่างน้อย 8 อักขระ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b891407480 = messageFormatterFn((function(  ) {
  return function(d) { return "ดำเนินการต่อด้วยบัญชีที่เชื่อมโยง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1123414818 = messageFormatterFn((function(  ) {
  return function(d) { return "หรือตั้งรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1172638296 = messageFormatterFn((function(  ) {
  return function(d) { return "เช็คอีเมลของคุณ!"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a823090031 = messageFormatterFn((function(  ) {
  return function(d) { return "เราส่งลิงก์ยืนยันไปยัง " + d["0"] + " เพื่อตั้งรหัสผ่านบัญชีแล้ว อาจใช้เวลาสักครู่ หากไม่พบอีเมลในกล่องข้อความเข้า กรุณาตรวจสอบโฟลเดอร์ขยะหรือโฟลเดอร์สแปม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1929625869 = messageFormatterFn((function(  ) {
  return function(d) { return "ตั้งรหัสผ่าน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b916741943 = messageFormatterFn((function(  ) {
  return function(d) { return "แก้ไข"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1259425653 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณเคยจองกับเราแล้ว เราจำเป็นต้องยืนยันอีเมลของคุณ เพื่อเหตุผลด้านความปลอดภัย"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a345891735 = messageFormatterFn((function(  ) {
  return function(d) { return "ใช้ลิงก์ยืนยันที่เราส่งไปยัง " + d["0"] + " เพื่อสร้างบัญชีให้เสร็จสมบูรณ์ การส่งอีเมลอาจใช้เวลาสักครู่ หากไม่พบอีเมลในกล่องข้อความเข้า กรุณาตรวจสอบโฟลเดอร์ขยะหรือโฟลเดอร์สแปม"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1450962631 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้อมูลการเดินทางของฉัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b973150036 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้อมูลบัญชีของฉัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1830010194 = messageFormatterFn((function(  ) {
  return function(d) { return "อัพเดทข้อมูลส่วนตัวและปรับการตั้งค่า"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1563447832 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้อมูล TSA"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a345642172 = messageFormatterFn((function(  ) {
  return function(d) { return "เพิ่มหมายเลขประจำตัว KTN หรือ Redress"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b534383882 = messageFormatterFn((function(  ) {
  return function(d) { return "ข้อมูลส่วนตัว"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a928692250 = messageFormatterFn((function(  ) {
  return function(d) { return "แชร์ข้อมูลทั่วไปและข้อมูลติดต่อ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1312296753 = messageFormatterFn((function(  ) {
  return function(d) { return "ลักษณะเที่ยวบินที่ต้องการ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a187631253 = messageFormatterFn((function(  ) {
  return function(d) { return "กำหนดลักษณะเที่ยวบินในแบบของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1596436288 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรแกรมสมาชิก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1501749276 = messageFormatterFn((function(  ) {
  return function(d) { return "บันทึกโปรแกรมสะสมไมล์และโปรแกรมอื่นๆ ที่คุณเป็นสมาชิก"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1903599502 = messageFormatterFn((function(  ) {
  return function(d) { return "หนังสือเดินทาง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a81820310 = messageFormatterFn((function(  ) {
  return function(d) { return "บันทึกข้อมูลหนังสือเดินทางเพื่อความรวดเร็วในการจอง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b335293077 = messageFormatterFn((function(  ) {
  return function(d) { return "การจัดการอุปกรณ์"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b984888241 = messageFormatterFn((function(  ) {
  return function(d) { return "ตรวจสอบอุปกรณ์ที่คุณใช้เข้าสู่ระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b656910423 = messageFormatterFn((function(  ) {
  return function(d) { return "เข้าสู่ระบบเพื่อดูบัญชีของคุณ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1021631206 = messageFormatterFn((function(  ) {
  return function(d) { return "สร้างบัญชี"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1431656167 = messageFormatterFn((function(  ) {
  return function(d) { return "ขออภัย เกิดข้อผิดพลาดในระบบ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a750987858 = messageFormatterFn((function(  ) {
  return function(d) { return "คุณออฟไลน์อยู่ โปรดตรวจสอบสัญญาณอินเทอร์เน็ต แล้วลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1709260532 = messageFormatterFn((function(  ) {
  return function(d) { return "โปรดลองอีกครั้ง"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a1751520125 = messageFormatterFn((function(  ) {
  return function(d) { return "กำลังโหลด..."; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1176942558 = messageFormatterFn((function(  ) {
  return function(d) { return "1 คืน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1112458198 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " คืน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.a297402646 = messageFormatterFn((function(  ) {
  return function(d) { return "เสร็จสิ้น คุณได้เลือกเข้าพัก 1 คืน บันทึกการเปลี่ยนแปลงและปิดปฏิทิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1671063138 = messageFormatterFn((function(  ) {
  return function(d) { return "เสร็จสิ้น คุณได้เลือกเข้าพัก " + d["0"] + " คืน บันทึกการเปลี่ยนแปลงและปิดปฏิทิน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1525512293 = messageFormatterFn((function(  ) {
  return function(d) { return "เลือกวัน"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b643216060 = messageFormatterFn((function(  ) {
  return function(d) { return "พบผลการค้นหา " + d["0"] + " รายการ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b1493772356 = messageFormatterFn((function(  ) {
  return function(d) { return "พบผลการค้นหา 1 รายการ"; }
})(), Globalize("th-TH").pluralGenerator({}));
Globalize.b698926408 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1813472776 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1522686901 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1649826437 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1759331752 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a1225983565 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a38390264 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1705190728 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1175696456 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b1764258293 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1817215576 = dateToPartsFormatterFn({"2":Globalize("th-TH").numberFormatter({"raw":"00"}),"4":Globalize("th-TH").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b1700978009 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"อา","mon":"จ","tue":"อ","wed":"พ","thu":"พฤ","fri":"ศ","sat":"ส"}}}});
Globalize.b747637768 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"วันอาทิตย์","mon":"วันจันทร์","tue":"วันอังคาร","wed":"วันพุธ","thu":"วันพฤหัสบดี","fri":"วันศุกร์","sat":"วันเสาร์"}}}});
Globalize.b2000883208 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"มกราคม","2":"กุมภาพันธ์","3":"มีนาคม","4":"เมษายน","5":"พฤษภาคม","6":"มิถุนายน","7":"กรกฎาคม","8":"สิงหาคม","9":"กันยายน","10":"ตุลาคม","11":"พฤศจิกายน","12":"ธันวาคม"}}}});
Globalize.b728345112 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b1289068693 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"}),"2":Globalize("th-TH").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.b32023690 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"ม.ค.","2":"ก.พ.","3":"มี.ค.","4":"เม.ย.","5":"พ.ค.","6":"มิ.ย.","7":"ก.ค.","8":"ส.ค.","9":"ก.ย.","10":"ต.ค.","11":"พ.ย.","12":"ธ.ค."}}}});
Globalize.b1012095533 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"มกราคม","2":"กุมภาพันธ์","3":"มีนาคม","4":"เมษายน","5":"พฤษภาคม","6":"มิถุนายน","7":"กรกฎาคม","8":"สิงหาคม","9":"กันยายน","10":"ตุลาคม","11":"พฤศจิกายน","12":"ธันวาคม"}}}});
Globalize.a746830658 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM G y","timeSeparator":":","months":{"M":{"4":{"1":"มกราคม","2":"กุมภาพันธ์","3":"มีนาคม","4":"เมษายน","5":"พฤษภาคม","6":"มิถุนายน","7":"กรกฎาคม","8":"สิงหาคม","9":"กันยายน","10":"ตุลาคม","11":"พฤศจิกายน","12":"ธันวาคม"}}},"eras":{"0":"ก่อน ค.ศ.","1":"ค.ศ.","0-alt-variant":"ก่อน ส.ศ.","1-alt-variant":"ส.ศ."}});
Globalize.b1638537314 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"MMMM G y","timeSeparator":":","months":{"M":{"4":{"1":"มกราคม","2":"กุมภาพันธ์","3":"มีนาคม","4":"เมษายน","5":"พฤษภาคม","6":"มิถุนายน","7":"กรกฎาคม","8":"สิงหาคม","9":"กันยายน","10":"ตุลาคม","11":"พฤศจิกายน","12":"ธันวาคม"}}},"eras":{"0":"ก่อน ค.ศ.","1":"ค.ศ.","0-alt-variant":"ก่อน ส.ศ.","1-alt-variant":"ส.ศ."}});
Globalize.b1637852121 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"ม.ค.","2":"ก.พ.","3":"มี.ค.","4":"เม.ย.","5":"พ.ค.","6":"มิ.ย.","7":"ก.ค.","8":"ส.ค.","9":"ก.ย.","10":"ต.ค.","11":"พ.ย.","12":"ธ.ค."}}}});
Globalize.a1777518774 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"EEEEที่ d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"วันอาทิตย์","mon":"วันจันทร์","tue":"วันอังคาร","wed":"วันพุธ","thu":"วันพฤหัสบดี","fri":"วันศุกร์","sat":"วันเสาร์"}}},"months":{"M":{"3":{"1":"ม.ค.","2":"ก.พ.","3":"มี.ค.","4":"เม.ย.","5":"พ.ค.","6":"มิ.ย.","7":"ก.ค.","8":"ส.ค.","9":"ก.ย.","10":"ต.ค.","11":"พ.ย.","12":"ธ.ค."}}}});
Globalize.b1019483701 = dateToPartsFormatterFn({"1":Globalize("th-TH").numberFormatter({"raw":"0"})}, {"pattern":"E d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"อา.","mon":"จ.","tue":"อ.","wed":"พ.","thu":"พฤ.","fri":"ศ.","sat":"ส."}}},"months":{"M":{"3":{"1":"ม.ค.","2":"ก.พ.","3":"มี.ค.","4":"เม.ย.","5":"พ.ค.","6":"มิ.ย.","7":"ก.ค.","8":"ส.ค.","9":"ก.ย.","10":"ต.ค.","11":"พ.ย.","12":"ธ.ค."}}}});
Globalize.b320212657 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1434759025 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a292230306 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b830223652 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1380618001 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1254066524 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a417104015 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1326476977 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b796982705 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a50658914 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b2099037969 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1852151376 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1583798321 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a1457923535 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b145061519 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"d"}));
Globalize.b1680475774 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a395834879 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b633381782 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b397944949 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b1259823563 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b1259138370 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a1159788223 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b640769950 = dateFormatterFn(Globalize("th-TH").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1293849086 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a179302718 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b497150703 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b1619604661 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a233443742 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b2043447533 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a2031165758 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a287584766 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a817079038 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b738722095 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b484976226 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.b46016607 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^อา/],["thu",/^พฤ/],["mon",/^จ/],["tue",/^อ/],["wed",/^พ/],["fri",/^ศ/],["sat",/^ส/]]});
Globalize.a1799600062 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^วันพฤหัสบดี/],["sun",/^วันอาทิตย์/],["mon",/^วันจันทร์/],["tue",/^วันอังคาร/],["fri",/^วันศุกร์/],["sat",/^วันเสาร์/],["wed",/^วันพุธ/]]});
Globalize.a546354622 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^กุมภาพันธ์/],["11",/^พฤศจิกายน/],["6",/^มิถุนายน/],["5",/^พฤษภาคม/],["7",/^กรกฎาคม/],["8",/^สิงหาคม/],["9",/^กันยายน/],["12",/^ธันวาคม/],["1",/^มกราคม/],["3",/^มีนาคม/],["4",/^เมษายน/],["10",/^ตุลาคม/]]});
Globalize.b1702848542 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b1524872783 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.a1694827376 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["3",/^มี\.ค\./],["4",/^เม\.ย\./],["6",/^มิ\.ย\./],["1",/^ม\.ค\./],["2",/^ก\.พ\./],["5",/^พ\.ค\./],["7",/^ก\.ค\./],["8",/^ส\.ค\./],["9",/^ก\.ย\./],["10",/^ต\.ค\./],["11",/^พ\.ย\./],["12",/^ธ\.ค\./]]});
Globalize.a980679961 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^กุมภาพันธ์/],["11",/^พฤศจิกายน/],["6",/^มิถุนายน/],["5",/^พฤษภาคม/],["7",/^กรกฎาคม/],["8",/^สิงหาคม/],["9",/^กันยายน/],["12",/^ธันวาคม/],["1",/^มกราคม/],["3",/^มีนาคม/],["4",/^เมษายน/],["10",/^ตุลาคม/]]});
Globalize.b1901638468 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM G y","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^กุมภาพันธ์/],["11",/^พฤศจิกายน/],["6",/^มิถุนายน/],["5",/^พฤษภาคม/],["7",/^กรกฎาคม/],["8",/^สิงหาคม/],["9",/^กันยายน/],["12",/^ธันวาคม/],["1",/^มกราคม/],["3",/^มีนาคม/],["4",/^เมษายน/],["10",/^ตุลาคม/]],"gregorian/eras/eraAbbr":[["0",/^ก่อน ค\.ศ\./],["0-alt-variant",/^ก่อน ส\.ศ\./],["1",/^ค\.ศ\./],["1-alt-variant",/^ส\.ศ\./]]});
Globalize.a354238180 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM G y","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^กุมภาพันธ์/],["11",/^พฤศจิกายน/],["6",/^มิถุนายน/],["5",/^พฤษภาคม/],["7",/^กรกฎาคม/],["8",/^สิงหาคม/],["9",/^กันยายน/],["12",/^ธันวาคม/],["1",/^มกราคม/],["3",/^มีนาคม/],["4",/^เมษายน/],["10",/^ตุลาคม/]],"gregorian/eras/eraAbbr":[["0",/^ก่อน ค\.ศ\./],["0-alt-variant",/^ก่อน ส\.ศ\./],["1",/^ค\.ศ\./],["1-alt-variant",/^ส\.ศ\./]]});
Globalize.a354923373 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["3",/^มี\.ค\./],["4",/^เม\.ย\./],["6",/^มิ\.ย\./],["1",/^ม\.ค\./],["2",/^ก\.พ\./],["5",/^พ\.ค\./],["7",/^ก\.ค\./],["8",/^ส\.ค\./],["9",/^ก\.ย\./],["10",/^ต\.ค\./],["11",/^พ\.ย\./],["12",/^ธ\.ค\./]]});
Globalize.b780672080 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEที่ d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^วันพฤหัสบดี/],["sun",/^วันอาทิตย์/],["mon",/^วันจันทร์/],["tue",/^วันอังคาร/],["fri",/^วันศุกร์/],["sat",/^วันเสาร์/],["wed",/^วันพุธ/]],"gregorian/months/format/abbreviated":[["3",/^มี\.ค\./],["4",/^เม\.ย\./],["6",/^มิ\.ย\./],["1",/^ม\.ค\./],["2",/^ก\.พ\./],["5",/^พ\.ค\./],["7",/^ก\.ค\./],["8",/^ส\.ค\./],["9",/^ก\.ย\./],["10",/^ต\.ค\./],["11",/^พ\.ย\./],["12",/^ธ\.ค\./]]});
Globalize.a973291793 = dateParserFn(Globalize("th-TH").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^อา\./],["thu",/^พฤ\./],["mon",/^จ\./],["tue",/^อ\./],["wed",/^พ\./],["fri",/^ศ\./],["sat",/^ส\./]],"gregorian/months/format/abbreviated":[["3",/^มี\.ค\./],["4",/^เม\.ย\./],["6",/^มิ\.ย\./],["1",/^ม\.ค\./],["2",/^ก\.พ\./],["5",/^พ\.ค\./],["7",/^ก\.ค\./],["8",/^ส\.ค\./],["9",/^ก\.ย\./],["10",/^ต\.ค\./],["11",/^พ\.ย\./],["12",/^ธ\.ค\./]]});
module.exports = Globalize;
